import { render, staticRenderFns } from "./RoutineDetails.vue?vue&type=template&id=5e33017f&"
import script from "./RoutineDetails.vue?vue&type=script&lang=js&"
export * from "./RoutineDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports